import { RootState } from "store";
import { FC, useState } from "react";
import styled from "styled-components";

import ContactList from "../../ContactList/ContactList";
import { TAB_TYPES } from "constants/types/tabTypes";
import { shallowEqual, useSelector } from "react-redux";

interface IAudience {
  tabType?: string;
  page?: string;
  title?: string;
  tab?: string;
}

const Audience: FC<IAudience> = (props) => {
  const { tabType } = props;
  const [toggle, setToggle] = useState(false);

  const toggleAsider = () => {
    setToggle(!toggle);
  };

  const [isAssetLinkedToCampaign, setIsAssetLinkedToCampaign] = useState(
    localStorage.getItem("campaign_id") || ""
  );

  const isAssetLinkedToCampaignFromRedux: any = useSelector(
    (state: RootState) => state.campaignDataForAsset.data.campaignId,
    shallowEqual
  );

  return (
    <Wrapper>
      <div className="wrapper-box">
        <div className="margin-top-contact-list">
          <ContactList isAudiencePage />
        </div>
      </div>
    </Wrapper>
  );
};

export default Audience;

const Wrapper = styled.div`
  .wrapper-box {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    .margin-top-contact-list {
      /* position: relative;
      z-index: 1; */
    }
  }
  .message-wrapper {
    margin-bottom: 138px;
  }
`;
